import script from "./RichText.vue?vue&type=script&setup=true&lang=ts"
export * from "./RichText.vue?vue&type=script&setup=true&lang=ts"

import "./RichText.vue?vue&type=style&index=0&id=028d0e31&lang=scss"

const __exports__ = script;

export default __exports__